import { render, staticRenderFns } from "./OrderInvoice.vue?vue&type=template&id=0482986f&scoped=true&"
var script = {}
import style0 from "./OrderInvoice.vue?vue&type=style&index=0&id=0482986f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0482986f",
  null
  
)

export default component.exports